<div 
  class="page-header d-flex justify-content-between" 
  style="z-index: 99;">
  
  <div *ngIf="isSubclient" class="nav-item mt-auto">
    <a 
      class="nav-link align-middle px-0 pointer"
      style="color: white;" 
      (click)="logout()">
      
      <img 
        class="pointer icon-size me-3"
        style="width: 24px; height: 24px;"
        src="../../assets/icons/logout.svg" 
        alt="Sair">

      <span class="ms-4 d-none d-sm-inline medium fs-6">Sair</span>
    </a>
  </div>

  <p *ngIf="!isSubclient" class="mt-auto mb-auto">{{getPortalTitle()}}</p>

  <div class="ps-4">
    <img 
      src="/assets/images/logo_1x.png" 
      class="center" 
      loading="lazy" 
      alt="Logo" 
      style="width: 206px; height: 50px;">
  </div>
</div>